"use strict";

import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useEffect, useState } from 'react';
import { VehicleLookupItemRenderer, VehicleLookupTitleRenderer } from '../../components/VehicleLookupItemRenderer';
import { VehicleLookupMessageRenderer } from '../../components/VehicleLookupItemRenderer/VehicleLookupMessageRenderer';
import { stringMatchWeight } from '../helpers/stringMatchWeight';
import { jsx as _jsx } from "react/jsx-runtime";
const optionRenderer = option => {
  switch (option.value.payload) {
    case groupTitlePayload:
      {
        return /*#__PURE__*/_jsx(VehicleLookupTitleRenderer, {
          suggestion: option.value
        });
      }
    case waitingMessagePayload:
      {
        return /*#__PURE__*/_jsx(VehicleLookupMessageRenderer, {
          suggestion: option.value
        });
      }
    default:
      {
        return /*#__PURE__*/_jsx(VehicleLookupItemRenderer, {
          suggestion: option.value,
          highlighted: option.highlight
        });
      }
  }
};
const groupTitlePayload = {
  code: 'GROUP_TITLE'
};
const waitingMessagePayload = {
  code: 'WAITING'
};
const getGroupTitle = (title = '') => ({
  text: title,
  payload: groupTitlePayload,
  skip: true
});
const getWaitingMessage = title => ({
  text: title,
  payload: waitingMessagePayload,
  skip: true
});
const vehicleToAutoSuggest = vehicle => ({
  text: vehicle.name,
  payload: vehicle
});
const sortMakesByPopularity = vehicleMakes => vehicleMakes.slice() // Unfreeze the list coming from relay
.sort((vehicleA, vehicleB) => {
  if (vehicleA.isPopular && !vehicleB.isPopular) {
    return -1;
  }
  if (!vehicleA.isPopular && vehicleB.isPopular) {
    return 1;
  }
  return vehicleA.name > vehicleB.name ? 1 : -1;
});
const buildSuggestion = (vehicles, query, popularOptionsGroupTitle, nonePopularOptionsGroupTitle) => {
  if (typeof query === 'string') {
    return vehicles.map(vehicle => _objectSpread(_objectSpread({}, vehicle), {}, {
      weight: stringMatchWeight(query, vehicle.name)
    })).filter(vehicle => vehicle.weight > 0).sort((vehicleA, vehicleB) => vehicleA.weight > vehicleB.weight ? -1 : vehicleA.weight < vehicleB.weight ? 1 : null).map(vehicleToAutoSuggest);
  }
  const suggestions = vehicles.map(vehicleToAutoSuggest);
  const popularOptions = suggestions.filter(suggestion => suggestion.payload.isPopular);
  const unPopularOptions = suggestions.filter(suggestion => !suggestion.payload.isPopular);

  // The below works because there'll we only need headings when we have both sets
  const shouldShowGroupHeadings = popularOptions.length > 0 && unPopularOptions.length > 0;
  return [shouldShowGroupHeadings && getGroupTitle(popularOptionsGroupTitle)].concat(_toConsumableArray(popularOptions), [shouldShowGroupHeadings && getGroupTitle(nonePopularOptionsGroupTitle)], _toConsumableArray(unPopularOptions)).filter(Boolean);
};
export const useVehicleLookup = ({
  vehicles,
  query: incomingQuery,
  popularOptionsGroupTitle,
  nonePopularOptionsGroupTitle,
  waitingMessage
}) => {
  const [query, setQuery] = useState(incomingQuery);
  const [suggestions, setSuggestions] = useState([]);
  useEffect(() => {
    setSuggestions(waitingMessage ? [getWaitingMessage(waitingMessage)] : buildSuggestion(sortMakesByPopularity(vehicles), query, popularOptionsGroupTitle, nonePopularOptionsGroupTitle));
  }, [vehicles, query, waitingMessage]);
  return {
    setQuery,
    suggestions,
    optionRenderer
  };
};